import React from 'react';

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  full = false,
  disabled = false,
  iconLeft = null,
  iconRight = null,
  onClick,
  type = 'button',
  style = {},
  ...rest
}) {
  const heights = { sm: 'var(--control-h-sm)', md: 'var(--control-h-md)', lg: 'var(--control-h-lg)' };
  const pads = { sm: '0 18px', md: '0 26px', lg: '0 34px' };
  const fonts = { sm: 'var(--fs-sm)', md: 'var(--fs-body)', lg: 'var(--fs-body)' };

  const variants = {
    primary: { background: 'var(--accent)', color: 'var(--accent-contrast)', border: '1px solid transparent' },
    energy:  { background: 'var(--energy)', color: 'var(--energy-contrast)', border: '1px solid transparent' },
    outline: { background: 'transparent', color: 'var(--accent)', border: '1.5px solid var(--accent)' },
    ghost:   { background: 'transparent', color: 'var(--text-strong)', border: '1px solid transparent' },
    glass:   { background: 'var(--glass-dark-bg)', color: 'var(--text-on-dark)', border: '1px solid var(--glass-dark-border)', backdropFilter: 'blur(var(--glass-blur))', WebkitBackdropFilter: 'blur(var(--glass-blur))' },
  };

  const base = {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '0.6em',
    height: heights[size], padding: pads[size], width: full ? '100%' : 'auto',
    fontFamily: 'var(--font-ui)', fontSize: fonts[size], fontWeight: 'var(--fw-bold)',
    letterSpacing: '0.01em', lineHeight: 1, borderRadius: 'var(--radius-pill)',
    cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1,
    transition: 'transform var(--dur-fast) var(--ease-out), box-shadow var(--dur-med) var(--ease-out), background var(--dur-fast) var(--ease-out)',
    whiteSpace: 'nowrap', ...variants[variant], ...style,
  };

  const hoverShadow = { primary: 'var(--glow-blue)', energy: 'var(--glow-green)', outline: 'var(--glow-blue)', ghost: 'none', glass: 'var(--glow-green)' }[variant];

  const onEnter = (e) => {
    if (disabled) return;
    e.currentTarget.style.transform = 'translateY(-2px)';
    e.currentTarget.style.boxShadow = hoverShadow;
    if (variant === 'primary') e.currentTarget.style.background = 'var(--accent-hover)';
    if (variant === 'energy')  e.currentTarget.style.background = 'var(--energy-hover)';
    if (variant === 'outline') e.currentTarget.style.background = 'var(--accent-soft)';
    if (variant === 'ghost')   e.currentTarget.style.background = 'var(--surface-sunken)';
  };
  const onLeave = (e) => {
    if (disabled) return;
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = 'none';
    e.currentTarget.style.background = variants[variant].background;
  };
  const onDown = (e) => { if (!disabled) e.currentTarget.style.transform = 'scale(0.97)'; };
  const onUp   = (e) => { if (!disabled) e.currentTarget.style.transform = 'translateY(-2px)'; };

  return (
    <button type={type} disabled={disabled} onClick={onClick} style={base}
      onMouseEnter={onEnter} onMouseLeave={onLeave} onMouseDown={onDown} onMouseUp={onUp} {...rest}>
      {iconLeft}{children}{iconRight}
    </button>
  );
}
